// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 * All Rights Reserved
 * CTAG:COMMUNITY
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community': []
})(this, function (m_module, Backbone, $, moment, _) {
  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};

  M.Community.View.CommunityComment = Backbone.View.extend({

    template: M.Template.Community.SubmitComment,
    className: 'communityComment',

    events: {
      'click .submitCommentButton': 'submitComment',
    },

    initialize: function() {
      M.required(this.options.designId);
      M.required(this.options.urlPaths);
    },

    render: function() {
      this.$el.html(this.template());
      return this;
    },

    submitComment: function() {
      var text = this.$el.find('.commentInput').val();
      var designId = this.options.designId;
      var communityComment = this.$el.parent().find('.communityComment');
      var submitCommentButton = this.$el.find("button");
      if (text && text.trim()) {
        // Disable the button onClick to prevent multiple click events
        submitCommentButton.prop('disabled', true).addClass('disabled');

        var comment = new M.Model.CommunityComment({
          text: text,
          design_id: designId,
          urlPaths: this.options.urlPaths
        });
        // Save the comment
        comment.save({},{
          success: function() {
            // TODO: put in separate template
            communityComment.html(
              '<p>Thank you for submitting your comment. ' +
              '<a href="/design-rating/' + encodeURIComponent(designId) +
              '#comments">See all comments</a>.</p>');
          },
          error: function() {
            // TODO: put in separate template
            communityComment.html(
              '<p>Something went wrong submitting your comment.' +
              ' Please try again later or <a href="/design-rating/' +
              encodeURIComponent(designId) + '#comments">see all comments</a>.</p>');
          }
        });

      }
    }
  });

  return {};

});